<template>
  <div>
    <span>
      <b-button v-on:click="edit()" size="sm" variant="outline-light">
        <Icon
          icon="material-symbols:edit"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="$t('Edit')"
          color="#7367F0"
        />
      </b-button>
    </span>
    <span>
      <b-button v-on:click="deleteData()" size="sm" variant="outline-light">
        <Icon
          icon="ic:baseline-remove-circle"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="$t('Delete')"
          color="#ea5455"
        />
      </b-button>
    </span>
    <span>
      <b-button v-on:click="addCustomerAct()" size="sm" variant="outline-light">
        <Icon
          icon="ant-design:product-filled"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="$t('AddNew') + ' ' + $t('CustomerAct')"
          color="#FF9F43"
        />
      </b-button>
    </span>
    <span>
      <b-button v-on:click="addCustomerInfo()" size="sm" variant="outline-light">
        <Icon
          icon="icon-park-outline:view-grid-detail"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="$t('AddNew') + ' ' + $t('Marketplace')"
          color="#FF9F43"
        />
      </b-button>
    </span>
    <span>
      <b-button v-on:click="addEmployee()" size="sm" variant="outline-light">
        <Icon
          icon="clarity:employee-line"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="$t('AddNew') + ' ' + $t('EmployeeId')"
          color="#17c3b2"
        />
      </b-button>
    </span>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  props: ["addMethods", "addMethodsEmployee"],
  components: { Icon },
  methods: {
    edit() {
      this.$root.$emit("editData", this.params.data);
    },
    deleteData() {
      this.$root.$emit("deleteData", this.params.data);
    },
    addCustomerInfo() {
      this.$root.$emit(this.params.addMethods, this.params.data);
    },
    addEmployee() {
      this.$root.$emit(this.params.addMethodsEmployee, this.params.data);
    },
    addCustomerAct() {
      this.$root.$emit("addCustomerAct", this.params.data);
    },
  },
};
</script>
